<!--
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-10 21:19:08
 * @LastEditTime: 2020-10-08 16:49:38
 * @Description: 添加编辑储罐借用抽屉
-->
<template>
  <Drawer
    width="400"
    :title="`${openedTankRental ? '编辑' : '新增'}储罐借用`"
    v-model="drawerOpened"
  >
    <div class="drawer-content">
      <Form
        @submit.native.prevent
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <FormItem label="公司" prop="company">
          <Select v-model="formItem.company">
            <Option
              v-for="company in companyList"
              :value="company._id"
              :key="company._id"
              >{{ company.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="容量/吨" prop="weight">
          <Input
            type="number"
            number
            v-model="formItem.weight"
            placeholder="输入容量..."
          />
        </FormItem>
        <FormItem label="数量/个" prop="quantity">
          <Input
            type="number"
            number
            v-model="formItem.quantity"
            placeholder="输入数量..."
          />
        </FormItem>
        <FormItem label="金额/元" prop="price">
          <Input
            type="number"
            number
            v-model="formItem.price"
            placeholder="输入金额..."
          />
        </FormItem>
        <FormItem label="借用日期" prop="rentalTime">
          <DatePicker
            type="date"
            v-model="formItem.rentalTime"
            style="width: 100%"
            placeholder="选择借用日期"
          ></DatePicker>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input v-model="formItem.remark" placeholder="输入备注..." />
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formItem')">保存</Button>
        </FormItem>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "AddTankRentalDrawer",
  props: ["customerId"],
  data() {
    return {
      drawerOpened: false,
      openedTankRental: null,
      formItem: {
        name: null,
        weight: null,
        quantity: null,
        price: null,
        rentalTime: null,
        company: null,
        remark: null,
      },
      ruleValidate: {
        weight: [
          {
            required: true,
            type: "number",
            message: "容量为必填项",
            trigger: "change",
          },
        ],
        quantity: [
          {
            required: true,
            type: "number",
            message: "数量为必填项",
            trigger: "change",
          },
        ],
        price: [
          {
            required: true,
            type: "number",
            message: "金额为必填项",
            trigger: "change",
          },
        ],
        company: [
          {
            required: true,
            type: "string",
            message: "公司为必填项",
            trigger: "blur",
          },
        ],
        rentalTime: [
          {
            required: true,
            type: "date",
            message: "借用日期为必填项",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      companyList: (state) => state.company.companyList,
    }),
  },
  methods: {
    ...mapActions({
      createTankRental: "tankRental/createTankRentalAction",
      updateTankRental: "tankRental/updateTankRentalAction",
      getCompanyList: "company/getCompanyListAction",
      getCustomerList: "customer/getCustomersAction",
    }),
    openDrawer(tankRental) {
      this.$refs["formItem"].resetFields();
      if (tankRental) {
        this.openedTankRental = tankRental;
        this.formItem.name = this.openedTankRental.name;
        this.formItem.remark = this.openedTankRental.remark;
        this.formItem.weight = this.openedTankRental.weight;
        this.formItem.quantity = this.openedTankRental.quantity;
        this.formItem.price = this.openedTankRental.price;
        this.formItem.rentalTime = this.openedTankRental.rentalTime;
        this.formItem.company = this.openedTankRental.company._id;
        this.formItem.customer = this.openedTankRental.customer._id;
      }
      this.drawerOpened = true;
    },
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            if (this.openedTankRental) {
              await this.updateTankRental({
                id: this.openedTankRental._id,
                data: this.formItem,
              });
            } else {
              this.formItem.customer = this.customerId;
              await this.createTankRental(this.formItem);
            }
            this.$Message.success("保存成功!");
            this.drawerOpened = false;
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
  },
  mounted() {
    this.getCompanyList({});
  },
};
</script>

<style scoped lang="stylus"></style>
